import React from 'react';
import DatePicker from 'antd/es/date-picker';
import styled from 'styled-components';

import { BaseInputProps, DescriptionFormItem } from './shared';

export const DateInput = ({
    label,
    name,
    rules,
    description = '',
    placeholder,
}: BaseInputProps) => {
    return (
        <DescriptionFormItem label={label} name={name} rules={rules} description={description}>
            <StyledDatePickerInput placeholder={placeholder} format="YYYY-MM-DD" />
        </DescriptionFormItem>
    );
};

const StyledDatePickerInput = styled(DatePicker)`
    width: 100%;
`;
